import { PrefixedID, Relationship } from '@griply/types';

export const buildRelationshipsMap = (
  relationships: Relationship[],
): Record<PrefixedID, PrefixedID[]> => {
  const relationshipsMap: Record<PrefixedID, PrefixedID[]> = {};

  // First, ensure all relationships are in the map
  relationships.forEach((relationship) => {
    // Add the relationship to the map for its own ID
    const relation = (relationshipsMap[relationship.id] =
      relationshipsMap[relationship.id] ?? []);

    // Loop over the references
    relationship.references.forEach((refId) => {
      // add all references that are not present yet
      if (!relation.includes(refId)) {
        relation.push(refId);
      }

      // add the reference as relation to the relationsMap - relations are both ways
      const referenceRelation = (relationshipsMap[refId] =
        relationshipsMap[refId] ?? []);

      // add the relationship if it is not present yet
      if (!referenceRelation.includes(relationship.id)) {
        relationshipsMap[refId].push(relationship.id);
      }
    });
  });

  return relationshipsMap;
};
